import { client } from '../graphql/client';
import {
    ADD_ORDERS_TO_CONSOLIDATION,
    AddOrdersToConsolidationResponse,
    AddOrdersToConsolidationVariables
} from '../pages/wms/consolidation/graphql/mutations/moveToConsolidation';
import {
    GET_AVAILABLE_CONSOLIDATION_TASKS,
    GetAvailableConsolidationTasksResponse,
    GetAvailableConsolidationTasksVariables
} from '../pages/wms/consolidation/graphql/queries/getAvailableConsolidationTasks';
import {
    GET_BAG_DETAIL,
    GetBagDetailResponse,
    GetBagDetailVariables
} from '../pages/wms/consolidation/graphql/queries/getBagDetail';
import { ConsolidationBagDetail, ConsolidationTaskOption } from '../pages/wms/consolidation/graphql/types/ConsolidationTypes';

export const getBagDetail = async (bagId: string): Promise<ConsolidationBagDetail> => {
    const { data } = await client.query<GetBagDetailResponse, GetBagDetailVariables>({
        query: GET_BAG_DETAIL,
        variables: { bagId }
    });
    if (!data) throw new Error('No data');
    return data.getBagDetail;
};

export const addOrdersToConsolidation = async (
    warehouseId: string,
    taskId: string,
    trackingNumbers: string[]
): Promise<AddOrdersToConsolidationResponse['addOrdersToConsolidation']> => {
    const { data } = await client.mutate<AddOrdersToConsolidationResponse, AddOrdersToConsolidationVariables>({
        mutation: ADD_ORDERS_TO_CONSOLIDATION,
        variables: { input: { warehouseId, taskId, trackingNumbers } }
    });
    if (!data) throw new Error('No data from addOrdersToConsolidation');
    return data.addOrdersToConsolidation;
};

export const getAvailableConsolidationTasks = async (warehouseId: string, type: number): Promise<ConsolidationTaskOption[]> => {
  const { data } = await client.query<GetAvailableConsolidationTasksResponse, GetAvailableConsolidationTasksVariables>({
    query: GET_AVAILABLE_CONSOLIDATION_TASKS,
    variables: { warehouseId, type }
  });
  if (!data) throw new Error('No data for available tasks');
  return data.getAvailableConsolidationTasks;
}; 